/*
 * @Author: liuYingBing
 * @Date: 2024-03-11 16:40:52
 * @LastEditors: liuYingBing
 * @LastEditTime: 2024-11-27 09:42:25
 * @FilePath: /fushigi/src/hooks/useEnv/index.ts
 * @Description:
 */
export function useEnv() {
  const {
    VITE_APP_RDP_WS,
    VITE_APP_BASE_URL,
    VITE_APP_LOGIN_URI,
    VITE_APP_HOME_URL,
    VITE_APP_HELP_URI,
    VITE_APP_BASE_API,
    VITE_APP_YUN_API,
    VITE_APP_YUN_SAVE_API,
    VITE_APP_YUN_TEST_API,
    VITE_APP_IFRAME_API,
    VITE_APP_TEST_COOKIE_API,
    VITE_APP_IFRAME_PREVIEW_API,
    VITE_APP_COMMUNITY_API,
    MODE,
    VITE_APP_ONE_API,
    VITE_APP_CLUB_API,
  } = import.meta.env
  const isProduction = MODE === 'production' || MODE === 'test'
  return {
    VITE_APP_RDP_WS,
    VITE_APP_BASE_URL,
    VITE_APP_LOGIN_URI,
    VITE_APP_HOME_URL,
    VITE_APP_HELP_URI,
    VITE_APP_BASE_API,
    VITE_APP_YUN_API,
    VITE_APP_YUN_SAVE_API,
    VITE_APP_YUN_TEST_API,
    VITE_APP_IFRAME_API,
    VITE_APP_TEST_COOKIE_API,
    VITE_APP_IFRAME_PREVIEW_API,
    VITE_APP_COMMUNITY_API,
    isProduction,
    VITE_APP_CLUB_API,
    VITE_APP_ONE_API,
  }
}
